import React from "react";
import Price from "../Price";
import { Link } from "gatsby";
import coursePrices from "../../data/coursePrices.json";


const FrenchCourseCard = ({ buyNow, viewCourse }) => {
  return (
    <>
      <section id="services" className="japanese-container">
        <div className={"row"}>
          <div align={"center"}>
            <br /> <br />
            <br />
            <h2 className="highlighted-text">
              {" "}
              <strong>French</strong> Courses By <span className="light-text"> Koderbox</span>{" "}
            </h2>
          </div>
          <div className="japanese-courses ">
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹6500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.french.a1.offerPrice.inr} usd={coursePrices.languages.french.a1.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">French A1 Course</h4>
              </div>{" "}
              <div>
                <ul>
                  <li>Basic French</li>
                  <li>Mode: Online</li>
                  <li>Duration: 1.5-2 Months</li>
                  <li>Expert Trainers</li>
                  <li>Affordable Price</li>
                  <li>Flexible Schedule</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price: <span className="highlighted-text strike">{this.state.inIndia ? "₹9000":"$200"} </span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.french.a1.originalPrice.inr} usd={coursePrices.languages.french.a1.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹7500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.french.a2.offerPrice.inr} usd={coursePrices.languages.french.a2.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">French A2 Course</h4>
              </div>
              <div>
                <ul>
                  <li>Intermediate Level</li>
                  <li>Mode: Online</li>
                  <li>Duration:2-3 Months</li>
                  <li>Expert Trainers</li>
                  <li>Affordable Price</li>
                  <li>Flexible Schedule</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price:<span className="highlighted-text strike">{this.state.inIndia ? "₹10000":"$200"}</span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.french.a2.originalPrice.inr} usd={coursePrices.languages.french.a2.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹7500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.french.b1.offerPrice.inr} usd={coursePrices.languages.french.b1.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">French B1 Course</h4>
              </div>
              <div>
                <ul>
                  <li>Advanced Beginner Level</li>
                  <li>Mode: Online</li>
                  <li>Duration:2.5-3.5 Months</li>
                  <li>Expert Trainers</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price:<span className="highlighted-text strike">{this.state.inIndia ? "₹10000":"$200"}</span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.french.b1.originalPrice.inr} usd={coursePrices.languages.french.b1.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹7500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.french.a1a2.offerPrice.inr} usd={coursePrices.languages.french.a1a2.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">French A1+A2 Combo Course</h4>
              </div>
              <div>
                <ul>
                  <li>Basic + Intermediate level</li>
                  <li>Mode: Online</li>
                  <li>Duration:3-4 Months</li>
                  <li>Expert Trainers</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price:<span className="highlighted-text strike">{this.state.inIndia ? "₹10000":"$200"}</span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.french.a1a2.originalPrice.inr} usd={coursePrices.languages.french.a1a2.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FrenchCourseCard;
